import genericCatalogue from './catalogues/generic-catalogue';
import sellCatalogue from './catalogues/sell-catalogue';
import cartCatalogue from './catalogues/cart-catalogue';

const translations = {
    en: {
        ...genericCatalogue.en,
        ...sellCatalogue.en,
        ...cartCatalogue.en,
    },
    ro: {
        ...genericCatalogue.ro,
        ...sellCatalogue.ro,
        ...cartCatalogue.ro,
    },
};

export default translations;
